import React from 'react';
import { PerformanceProvider } from '../../contexts/PerformanceContext';
import PerformanceDashboard from '../../components/PerformanceDashboard/PerformanceDashboard';
import PerformanceErrorBoundary from '../../components/PerformanceDashboard/PerformanceErrorBoundary';
import PerformanceAccessControl from '../../components/PerformanceDashboard/PerformanceAccessControl';

const PerformanceDashboardPage = () => {
  return (
    <PerformanceErrorBoundary>
      <PerformanceAccessControl 
        requiredRoles={['owner', 'broker', 'dealer', 'masterAdmin']}
        requiredPermissions={[]}
      >
        <PerformanceProvider>
          <PerformanceDashboard />
        </PerformanceProvider>
      </PerformanceAccessControl>
    </PerformanceErrorBoundary>
  );
};

export default PerformanceDashboardPage;
